import type { ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { NoteGrid } from "./note-grid";
import type { EnrichedPayrollPeriodNote } from "./types";

export const PayrollNoteRow = ({
  note,
  sent = false,
  children,
}: {
  note: EnrichedPayrollPeriodNote;
  sent?: boolean;
  children?: ReactNode;
}) => (
  <Stack gap={2} className="min-w-0 border-b border-line pb-3">
    <Stack direction="row" align="center" justify="between" gap={3}>
      <Text variant="caption" tone="muted">
        {note.authorLabel},{" "}
        {sent ? `for ${note.periodLabel}` : `from ${note.sourcePeriodLabel}`}
      </Text>
      <Text
        variant="caption"
        tone={note.status === "open" && !sent ? "default" : "muted"}
      >
        {sent && note.status === "open" ? "Open" : note.statusLabel}
      </Text>
    </Stack>
    {note.body && (
      <Text className="break-words whitespace-pre-wrap">{note.body}</Text>
    )}
    {note.grid_text !== null && <NoteGrid text={note.grid_text} copyable />}
    {(children || note.resolvedLabel) && (
      <Stack direction="row" align="center" gap={2} wrap>
        {children}
        {note.resolvedLabel && (
          <Text variant="caption" tone="muted">
            {note.resolvedLabel}
          </Text>
        )}
      </Stack>
    )}
  </Stack>
);
